'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { COUNTRY_CODE_US, CountryCode } from '@sola/schema/dotcom/shared/geo.ts';
import { usePhoneMask } from '../../utils/masks.ts';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
export type PhoneFieldProps = InputFieldProps & {
  countryCode: CountryCode;
};

// TODO: Right now we're loading the mask deps when field is in viewport.
// This can prob be optimized so that field deps are only lazy loaded when
// form is interacted with. We can't to this on a field level since inputs can
// be autofilled before masks are applied.
export const PhoneField: React.FC<PhoneFieldProps> = t0 => {
  const $ = _c(23);
  let fieldProps;
  let t1;
  if ($[0] !== t0) {
    ({
      countryCode: t1,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
    $[2] = t1;
  } else {
    fieldProps = $[1];
    t1 = $[2];
  }
  const countryCode = t1 === undefined ? COUNTRY_CODE_US : t1;
  const {
    mask,
    loadMask
  } = usePhoneMask(countryCode);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["forms"];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    t
  } = useTranslation(t2);
  const {
    name
  } = fieldProps;
  const {
    trigger,
    formState
  } = useFormContext();
  let t3;
  if ($[4] !== formState || $[5] !== name || $[6] !== trigger) {
    t3 = () => {
      if (!name) {
        return;
      }
      if (!formState.touchedFields[name]) {
        return;
      }
      trigger(name);
    };
    $[4] = formState;
    $[5] = name;
    $[6] = trigger;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== countryCode || $[9] !== name) {
    t4 = [countryCode, name];
    $[8] = countryCode;
    $[9] = name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  const t5 = mask?.placeholder;
  let t6;
  if ($[11] !== countryCode || $[12] !== fieldProps.required || $[13] !== t) {
    t6 = maskedValue => countryCode !== "US" || !fieldProps.required && !maskedValue || maskedValue.replace(/\D/g, "").length === 10 ? true : t("forms:errors.invalidPhone");
    $[11] = countryCode;
    $[12] = fieldProps.required;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== mask) {
    t7 = !!mask && {
      maskOptions: mask.options
    };
    $[15] = mask;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== fieldProps || $[18] !== loadMask || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <InputField type="tel" placeholder={t5} autoComplete="tel" onVisible={loadMask} validate={t6} {...fieldProps} {...t7} />;
    $[17] = fieldProps;
    $[18] = loadMask;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};